import filter from 'lodash/filter';
import get from 'lodash/get';
import size from 'lodash/size';
import defaultFields from 'store/KnowledgeBase/fields';
import { updatePreferences } from 'store/Preferences/actions';
import { selectFields } from './selectors';

export function setFieldVisibility (field, value) {
  return async (dispatch, getState) => {
    let kb_table = selectFields(getState());

    if (!kb_table) kb_table = { ...defaultFields };
    if (!kb_table[field].locked) {
      kb_table[field].visible = value;

      if (value) kb_table[field].order = Object.keys(kb_table).filter((key) => kb_table[key].visible).length;
      else {
        let cont = 1;
        Object.keys(kb_table).filter((f) => kb_table[f].visible).sort((a, b) => (kb_table[a].order < kb_table[b].order)).forEach((f2) => {
          kb_table[f2].order = cont;
          cont += 1;
        });
      }

      dispatch(updatePreferences({ kb_table }));
    }
  };
}

export function setNewOrderColumns (columns) {
  return async (dispatch, getState) => {
    let kb_table = selectFields(getState());
    if (!kb_table) kb_table = { ...defaultFields };

    const fixedColumns = size(filter(kb_table, { locked: true }));

    columns.forEach((column) => {
      if (column) {
        if (!get(kb_table, `${column}.locked`, false)) {
          kb_table[column].order = columns.indexOf(column) + 1 + fixedColumns;
        }
      }
    });

    dispatch(updatePreferences({ kb_table }));
  };
}

export function resetDefault () {
  return async (dispatch) => {
    dispatch(updatePreferences({ kb_table: defaultFields }));
  };
}
